export const hbConfig = {
    "14556": {
        "biddersMap": {
            "adwile": "2223826"
        },
        "biddersCpmAdjustmentMap": {
            'adwile': 0.7
        },
        "adUnits": [
            {
                "code": "adfox_17338228553905666",
                "bids": [
                    {
                        "bidder": "adwile",
                        "params": {
                            "placementId": "31855"
                        }
                    }
                ]
            }
        ],
        "timeout": 1000,
        "trustedOwners": [123456, 111111],
    }
}
